module.exports = __webpack_public_path__ + "img/pic_uk_03.46c7b287.jpg";